import React, { useRef, useState, useEffect } from 'react';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import '@splidejs/react-splide/css';
import './Hero.css';
import staticImage from "../../../../assets/images/package-img-default.png"
import Cookies from 'js-cookie';
import { useTranslation } from '../../../../contexts/TranslationContext';

const Hero = ({ packageData, url }) => {
  const mainRef = useRef(null);
  const thumbsRef = useRef(null);
  const [mainSplide, setMainSplide] = useState(null);
  const [thumbsSplide, setThumbsSplide] = useState(null);

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const Lang = Cookies.get("preferred_language") || "en";
  const { t } = useTranslation();

  useEffect(() => {
    function handleResize() {
      setIsMobile(window.innerWidth < 768);
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

    // Calculate number of days from activities
    let numberOfDays = '';

    if (packageData?.duration) {
      numberOfDays = Math.round(packageData.duration / (60 * 60 * 24));
    } else if (packageData?.activities && Object.keys(packageData.activities).length > 0) {
      numberOfDays = Object.keys(packageData.activities).length;
    }

    const images = packageData.gallery && packageData.gallery.length > 0 ? packageData.gallery : [{ image: staticImage, isStatic: true }];

  
  // Set up synchronization
  useEffect(() => {
    if (mainSplide && thumbsSplide) {
      mainSplide.sync(thumbsSplide);
      thumbsSplide.sync(mainSplide);
    }
  }, [mainSplide, thumbsSplide]);

  return (
    <div className="package-details-hero">
      <div className="details-main-slider">
        {/* Main Slider */}
        <Splide
          ref={mainRef}
          options={{
            // type: "fade",
            type: Lang === 'ar' ? 'slide' : 'fade', 
            heightRatio: 0.5,
            pagination: false,
            arrows: false,
            cover: true,
            direction: Lang === 'ar' ? 'rtl' : 'ltr'
          }}
          onMounted={(splide) => setMainSplide(splide)}
        >
          {images.map((img, idx) => (
            <SplideSlide key={idx}>
              <div className="image-container">
                <img
                  src={img.isStatic ? img.image : url + img.image}
                  alt={`Main ${idx}`}
                />
                <div className="image-overlay"></div>
                <div className="container">
                  <div className="details-main-slider-content">
                    <div className="details-main-slider-title">
                      {packageData.name1}
                    </div>
                    <div className=""></div>
                    <div className="details-main-slider-content-desc">
                      {packageData.destination_name && (
                        <div className="details-main-slider-location">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="19"
                            height="19"
                            viewBox="0 0 19 19"
                            fill="none"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M8.91575 17.5228C8.91575 17.5228 3.16667 12.6809 3.16667 7.91668C3.16667 6.23697 3.83393 4.62606 5.02166 3.43833C6.20939 2.2506 7.8203 1.58334 9.5 1.58334C11.1797 1.58334 12.7906 2.2506 13.9783 3.43833C15.1661 4.62606 15.8333 6.23697 15.8333 7.91668C15.8333 12.6809 10.0843 17.5228 10.0843 17.5228C9.76442 17.8173 9.23796 17.8141 8.91575 17.5228ZM9.5 10.6875C9.86388 10.6875 10.2242 10.6158 10.5604 10.4766C10.8965 10.3373 11.202 10.1332 11.4593 9.87595C11.7166 9.61866 11.9207 9.3132 12.0599 8.97703C12.1992 8.64086 12.2708 8.28055 12.2708 7.91668C12.2708 7.55281 12.1992 7.1925 12.0599 6.85633C11.9207 6.52015 11.7166 6.2147 11.4593 5.9574C11.202 5.70011 10.8965 5.49601 10.5604 5.35676C10.2242 5.21751 9.86388 5.14584 9.5 5.14584C8.76513 5.14584 8.06036 5.43777 7.54073 5.9574C7.0211 6.47703 6.72917 7.18181 6.72917 7.91668C6.72917 8.65155 7.0211 9.35632 7.54073 9.87595C8.06036 10.3956 8.76513 10.6875 9.5 10.6875Z"
                              fill="#E8E8E8"
                            />
                          </svg>
                          <div>{packageData.destination_name}</div>
                        </div>
                      )}
                      {numberOfDays && (
                        <div className="details-main-slider-days">
                          {numberOfDays} {t("Days")}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </SplideSlide>
          ))}
        </Splide>
      </div>
      {images.length > 1 && (
        <div
          className={`details-thumbnail-slider ${
            Lang === "ar" ? "slider-direction-ar" : "slider-direction-en"
          }`}
        >
          {/* Thumbnail Slider */}
          <Splide
            ref={thumbsRef}
            options={{
              height: isMobile ? undefined : "260px", // <-- height only for desktop
              perPage: 3,
              pagination: false,
              arrows: true,
              drag: false,
              focus: 0,
              direction: isMobile ? "ltr" : "ttb", // <-- direction switch
              fixedWidth: 100,
              fixedHeight: 80,
              gap: 10,
              cover: true,
              isNavigation: true,
            }}
            key={isMobile ? "mobile" : "desktop"} // force re-render on mobile/desktop switch
            onMounted={(splide) => setThumbsSplide(splide)}
            className="mt-4"
          >
            {images.map((img, idx) => (
              <SplideSlide key={idx}>
                <div className="image-container">
                  {/* <img src={url + img.image} alt={`Main ${idx}`} /> */}
                  <img
                    src={img.isStatic ? img.image : url + img.image}
                    alt={`Main ${idx}`}
                  />

                  <div className="image-overlay"></div>
                </div>
              </SplideSlide>
            ))}
          </Splide>
        </div>
      )}
    </div>
  );
};

export default Hero;